import { actionsServices } from "../../Services/CommonServices/action.services";



const citiesList = async (params) => {
    let param = params ? params : ''
    let response = await actionsServices.citiesList(param);
    if (response && response.status) {
        return response;
    } else {
        return null;
    }
};


const statesList = async (params) => {
    let param = params ? params : ''
    let response = await actionsServices.statesList(param);
    if (response && response.status) {
        return response;
    } else {
        return null;
    }
};


const taskPriorities = async (params) => {
    let param = params ? params : ''
    let response = await actionsServices.taskPriority(param);
    if (response && response.status) {
        return response;
    } else {
        return null;
    }
};


export const actionsController = {
    citiesList,
    statesList,
    taskPriorities
};